import React from 'react';

const featureData = [
  {
    category: 'Widgets & Elements',
    features: [
      { name: 'Free Widgets',                           free: '30+ Basic',        pro: true            },
      { name: 'Premium Pro Widgets',                    free: false,              pro: '65+ Advanced'  },
      { name: 'WooCommerce Widgets',                    free: false,              pro: '15+ Specialized'},
      { name: 'Form Stylers (CF7, WPForms)',            free: 'Basic',            pro: 'Advanced Pro'  },
      { name: 'Marketing & Conversion Elements',        free: false,              pro: true            },
      { name: 'Post & Archive Grid Widgets',            free: 'Basic',            pro: 'Extended Layouts'},
    ],
  },
  {
    category: 'Professional Extensions',
    features: [
      { name: 'Total Pro Extensions',                   free: false,              pro: '25+ Extensions'},
      { name: 'Conditional Content (Display Conditions)', free: false,            pro: true            },
      { name: 'Cross-Domain Copy Paste',                free: false,              pro: true            },
      { name: 'Advanced Sticky',                        free: false,              pro: true            },
      { name: 'Advanced Parallax',                      free: false,              pro: true            },
      { name: 'Image Masking',                          free: true,               pro: true            },
      { name: 'Content Protection (User Role Based)',   free: false,              pro: true            },
      { name: 'Floating Effects & Animations',          free: false,              pro: true            },
      { name: 'Advanced Tooltips',                      free: true,               pro: true            },
      { name: 'Wrapper Link (Make any column clickable)', free: false,            pro: true            },
    ],
  },
  {
    category: 'Power Modules',
    features: [
      { name: 'Total Pro Modules',                      free: false,              pro: '20+ Modules'   },
      { name: 'Header & Footer Builder',                free: false,              pro: true            },
      { name: 'Mega Menu Builder',                      free: false,              pro: true            },
      { name: 'Widget Builder',                         free: false,              pro: true            },
      { name: 'Modal / Popup Builder',                  free: false,              pro: true            },
      { name: 'Maintenance / Coming Soon Mode',         free: false,              pro: true            },
    ],
  },
  {
    category: 'Design & Templates',
    features: [
      { name: 'Premium Template Kits',                  free: 'Limited',          pro: '50+ Full Kits' },
      { name: 'Section Library Blocks',                 free: '20+',              pro: '200+ Premium'  },
      { name: 'Glassmorphism / Parallax',               free: false,              pro: true            },
      { name: 'Custom JS/CSS Per Widget',               free: false,              pro: true            },
    ],
  },
  {
    category: 'Development & Agency',
    features: [
      { name: 'Unlimited Local Servers',                free: true,               pro: true            },
      { name: 'Modular Control (Enable/Disable)',       free: true,               pro: true            },
      { name: 'White Labeling',                         free: false,              pro: 'Agency Plan'   },
      { name: 'On-Demand Asset Loading',                free: true,               pro: true            },
    ],
  },
  {
    category: 'Support & Maintenance',
    features: [
      { name: 'Automatic Updates',                      free: true,               pro: true            },
      { name: 'Ticket Support System',                  free: 'Community',        pro: true            },
      { name: 'Priority Support',                       free: false,              pro: true            },
      { name: 'Dedicated Video Tutorials',              free: true,               pro: true            },
    ],
  },
];

// Helper function to render a value or an icon
const renderFeatureValue = (value) => {
  if (value === true) {
    return <span className="thha-icon thha-icon-checkmark-circle fw-18"></span>;
  }
  if (value === false) {
    return <span className="thha-icon thha-icon-cancel-circle fw-18"></span>;
  }
  return value;
}; 

// Component for a single feature row
const FeatureRow = ({ name, free, pro, highlight }) => (
  <div className={`feature-row ${highlight ? 'highlight' : ''}`}>
    <div className="feature-name">{name}</div>
    <div className="feature-value free-value">
      {renderFeatureValue(free)}
    </div>
    <div className="feature-value pro-value">
      {renderFeatureValue(pro)}
    </div>
  </div>
);

// Component for a feature category
const FeatureCategory = ({ category, features }) => (
  <div className="feature-category">
    <h3 className="category-title">{category}</h3>
    {features.map((feature, index) => (
      <FeatureRow
        key={index}
        name={feature.name}
        free={feature.free}
        pro={feature.pro}
        highlight={feature.highlight}
      />
    ))}
  </div>
);

const showSidebar = true;
const showProPackages = false;

// Main Layout component
const FeatureComparison = () => (
  <div className="comparison-page-container">
    <div className="comparison-main-content">
      
      {/* Header Row */}
      <div className="comparison-header">
        <div className="header-spacer">Features of Huge Addons</div>
        <div className="prices">
          <div className="price-column free">
            <div className='type'>Free</div> <div className="plan-tag blue">Get Free <span className="thha-icon thha-icon-arrow fw-32"></span></div>
          </div> 
          <div className="boundary-line"></div>
          <div className="price-column pro">
            <div className='type'>Pro</div> <div className="plan-tag orange">Get Pro <span className="thha-icon thha-icon-arrow fw-32"></span></div>
          </div>
        </div>
      </div>
      
      {/* Feature Sections */}
      <div className="feature-table">
        {featureData.map((data, index) => (
          <FeatureCategory
            key={index}
            category={data.category}
            features={data.features}
          />
        ))}
      </div>
    </div>
    
    { showSidebar && (  
      <>
        {/* Right Sidebar/Addons Section */}
        <div className="comparison-sidebar">
            {/* Placeholder for the "Awesome Design" section */}
            <div className="sidebar-card design-promo">
                <div className="widget-image">
                  <img className="image-placeholder" src={window.thhaAdminSettings.assets_url + "img/unlock-pro-img.jpg"} alt="Huge Addons Pro" />
                </div>
                <p className='unlock-pro-text'><i className="thha-icon thha-icon-unlock-pro w24"></i> Unlock Pro Features</p>
                <h4>Awesome Design With Huge Addons Pro!</h4>
                <p className='description'>We designed huge addons to be intuitive but we do recommend learning how it works by checking our Widget</p>
                <ul className="widget-list">
                    <li><span className="thha-icon thha-icon-check w12"></span> Marketing Widget</li>
                    <li><span className="thha-icon thha-icon-check w12"></span> Marketing Widget</li>
                    <li><span className="thha-icon thha-icon-check w12"></span> Woo Commerce</li>
                    <li><span className="thha-icon thha-icon-check w12"></span> Woo Commerce</li>
                    <li><span className="thha-icon thha-icon-check w12"></span> Header and Footer Builder</li>
                    <li><span className="thha-icon thha-icon-check w12"></span> And More</li>
                </ul>
                { showProPackages && (
                  <div className="buy-section">
                      <select className="price-dropdown">
                          <option>Personal</option>
                          <option>Professional</option>
                          <option>Agency</option>
                      </select>
                      <div className="price-details">
                          <span className="current-price">$20/Annual</span>
                          <button className="buy-button">Buy Now</button>
                      </div>
                  </div> 
                )}
            </div>

            {/* Placeholder for the "Quick Access" section */}
            <div className="sidebar-card quick-access">
              <p className="quick-access-text"><i className="thha-icon thha-icon-support-user w24"></i> Support</p>
                <h4>Quick Access</h4>
                <p className='description'>We designed huge addons to be intuitive but we do recommend learning how it works by checking our</p>
                <ul className="access-list">
                    <li><span className="thha-icon thha-icon-call-center w14"></span> VIP Support <span className="pro-badge">pro</span></li>
                    <li><span className="thha-icon thha-icon-help-center w14"></span> Help Center</li>
                    <li><span className="thha-icon thha-icon-bubble-chat w14"></span> Join The Community</li>
                    <li><span className="thha-icon thha-icon-star w14"></span> Rate Us</li>
                </ul>
                {/* Image placeholder is here */}
                <div className="image-placeholder-small" style={{ backgroundImage: `url(${`${window.thhaAdminSettings.assets_url}img/quick_access.png`})`, marginRight: "12px" }}>
                </div>
            </div>
        </div>
      </>
    )}
  </div>
);

export default FeatureComparison;